<script setup>
    import EstimateForm from './EstimateForm.vue';
    import EstimateResults from './EstimateResults.vue';
    import QuoteForm from './QuoteForm.vue';
    import { useStore } from 'vuex';

    const store = useStore();
</script>

<template>
    
    <div class="container mobile-height">
        <div class="row d-flex">
            <div class="col-lg-6"><estimate-form></estimate-form></div>
            <div class="col-lg-6"><estimate-results></estimate-results></div>

        </div>
    </div>
    <QuoteForm
            ref="quoteForm"
            v-show="store.state.quoteFormVisible"
            @click="()=> store.commit('toggleQuote')"
            @close="()=> store.commit('toggleQuote')"
            ></QuoteForm>

</template>